<p-dialog [header]="headerTitle" [(visible)]="displayAddToList" (onHide)="closeDialog()" [modal]="true"
    [responsive]="true" [closable]="true" [style]="{width: '60vw'}">
    <div class="card">
        <form [formGroup]="addToListForm" novalidate>
            <div class="p-grid">
                <div class="p-col-12 p-lg-6">
                    <label>Module <span style="color: red;">*</span></label>
                    <p-dropdown
                        [options]="parentModules"
                        formControlName="selectedModule"
                        optionLabel="name"
                        optionValue="objectId"
                        [filter]="true"
                        placeholder="Select Module"
                        appendTo="body"
                        (onChange)="onChangeParentModule($event)">
                    </p-dropdown>
                    <div *ngIf="detailsFormErrors?.selectedModule" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedModule }}</small>
                    </div>
                </div>
                <div class="p-col-12 p-lg-6">
                    <label>Channel <span style="color: red;">*</span></label>
                    <p-dropdown
                        [options]="parentTemplates"
                        formControlName="selectedChannel"
                        optionLabel="channelName"
                        optionValue="channelId"
                        [filter]="true"
                        placeholder="Select Channel"
                        appendTo="body"
                        (onChange)="getModuleFields($event)">
                    </p-dropdown>
                    <div *ngIf="detailsFormErrors?.selectedChannel" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedChannel }}</small>
                    </div>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-lg-6">
                    <label>Module Column  <span *ngIf="savedSearchId" style="color: red;">*</span></label>
                    <!-- <p-dropdown formControlName="moduleField" optionLabel="name" [filter]="true" placeholder="Select Module Column" appendTo="body" ></p-dropdown> -->

                    <liono-treeSelect
                        [options]="moduleColumns"
                        [filter]="true"
                        filterPlaceholder="Search Fields..."
                        placeholder="Select Module Column"
                        appendTo="body"
                        formControlName="moduleField"
                        [scrollHeight]="'285px'"
                        [metaKeySelection]="false"
                        (onNodeSelect)="onFieldChangeRuleList($event)"
                        (onNodeUnselect)="onNodeUnselect($event)"
                        >
                    </liono-treeSelect>

                    <div *ngIf="detailsFormErrors?.moduleField" class="p-invalid">
                        <small>{{ detailsFormErrors?.moduleField }}</small>
                    </div>
                </div>
                <div class="p-col-12 p-lg-6">
                    <label>
                        {{ savedSearchId ? 'Saved Search Column' : 'Workbook Column' }}
                        <span *ngIf="savedSearchId" style="color: red;">*</span>
                    </label>
                    <p-dropdown
                        [options]="(savedSearchId ? savedSearchColumns : workbookColumns) | filterByFormControlType: addToListForm.get('moduleField')?.value : savedSearchId"
                        formControlName="referenceFieldId"
                        optionLabel="name"
                        [optionValue]="savedSearchId ? 'id' : 'intId'"
                        [filter]="true"
                        [placeholder]="savedSearchId ? 'Select Saved Search Field' : 'Select Workbook Field'"
                        appendTo="body"
                        [showClear]="true"
                        >
                    </p-dropdown>
                    <div *ngIf="detailsFormErrors?.referenceFieldId" class="p-invalid">
                        <small>{{ detailsFormErrors?.referenceFieldId }}</small>
                    </div>
                </div>
                
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-lg-6">
                    <label>List Type</label>
                    <div class="p-d-flex">
                        <div *ngFor="let widgetDetails of widgetTypes" class="p-d-flex p-mr-3">
                            <p-radioButton name="widgetType" [value]="widgetDetails" formControlName="widgetType" [inputId]="widgetDetails.id"></p-radioButton>
                            <label [for]="widgetDetails.id" class="p-ml-2">
                                {{ widgetDetails.description }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="p-col-12 p-lg-6">
                    <label>{{ addToListForm.value.widgetType?.description }} Name <span style="color: red;">*</span></label>
                    <input pInputText formControlName="widgetName"/>
                    <div *ngIf="detailsFormErrors?.widgetName" class="p-invalid">
                        <small>{{ detailsFormErrors?.widgetName }}</small>
                    </div>
                </div>
            </div>
         </form>
    </div>
    <p-footer>
        <button type="button" pButton (click)="closeDialog()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveWidget()" label="Save" [disabled]="submitLoading"></button>
    </p-footer>
</p-dialog>
